import { forwardRef } from 'react';

export function PanelHead({ title, meta, metaWrap = false, children }) {
  return (
    <div className="ledger-panel-head">
      {title ? <h2 className="ledger-panel-title">{title}</h2> : null}
      {children}
      {/* metaWrap: most meta text is a fixed short label that's meant to stay
          on one line, but some (e.g. Power rankings' "Week N, moved from
          week N-1", alongside two buttons in the same header) can be longer
          than the panel is wide. .ledger-state defaults to nowrap, which
          pushes the whole flex row past the panel's width on a narrow
          viewport instead of wrapping onto a second line. */}
      {meta ? <span className={`ledger-state${metaWrap ? ' is-wrap' : ''}`}>{meta}</span> : null}
    </div>
  );
}

export const Panel = forwardRef(function Panel(
  { title, meta, head, children, bodyClassName, className = '', ...rest },
  ref,
) {
  return (
    <section ref={ref} className={`ledger-panel ledger-scope ${className}`.trim()} {...rest}>
      {head ?? (title ? <PanelHead title={title} meta={meta} /> : null)}
      {bodyClassName === undefined ? children : <div className={bodyClassName}>{children}</div>}
    </section>
  );
});

export default Panel;
